import type { DeliveryPointLocale } from "@/locales/fr/delivery-point";

import { EPdlStatus } from "@/types/backoffice/dto/site/site-pdl-dto.ts";

const deliveryPointLocale: DeliveryPointLocale = {
  deliveryPoint: {
    title: "MPAN",
    deliveryPoint: "MPAN",
    deliveryPointNumber: "MPAN",
    deliveryPointInformation: "MPAN Information",
    noDeliveryPoint: "No MPAN",
    consent: "Consent",
    subscription: "Subscription",
    nonEligible: "Not eligible",
    subscribed: "Subscribed (Last reception {lastReception})",
    inProgress: "In progress",
    validateDeliveryPoint: "Validate MPAN",
    invalidateDeliveryPoint: "Invalidate MPAN",
    updateDeliveryPoint: "Update MPAN",
    searchDeliveryPoint: "Search for a MPAN",
    contractOwnerName: "Electricity contract holder's name",
    searchTypeManual: "Manual entry",
    errorDeliveryPointName: "The PDL name may only contain numbers and letters",
    errorDeliveryPointRequired: "The MPAN is required",
    status: {
      [EPdlStatus.VALID]: "Validated",
      [EPdlStatus.FORCED_VALID]: "MPAN validated by Voltalis",
      [EPdlStatus.PROCESSING]: "Validation in progress",
      [EPdlStatus.FORCED_INVALID]: "MPAN invalidated by Voltalis",
      [EPdlStatus.INVALID]: "Invalidated",
      [EPdlStatus.NOT_ENEDIS]: "Out of scope validation",
      [EPdlStatus.NOT_VERIFIED]: "Not verified",
    },
  },
};

export default deliveryPointLocale;
